{
  "about": {
    "title": "Spring Boot Admin 소개",
    "label": "소개"
  }
}
